import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-espelho-ponto',
  templateUrl: './espelho-ponto.component.html',
  styleUrls: ['./espelho-ponto.component.css']
})
export class EspelhoPontoComponent implements OnInit {

  mostraEspelho: boolean = false;
  loading: any = false;
  filtro: any = {};
  currentUser: any = {};
  listaEspelhos: any = [];
  dataEspelho: any = {};

  constructor(private apiService: ApiService, private router: Router) {
    try {
      if (localStorage.getItem("currentUser") == null)
        this.router.navigate(["/login"]);
      this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    } catch (err) {
      this.router.navigate(["/login"]);
    }
  }

  ngOnInit() {
  }

  detalhaEspelho() {
    this.mostraEspelho = !this.mostraEspelho;
  }

  obterFuncionarios(filtro) {
    if (filtro.mes == null || filtro.mes == "") {
      Swal.fire({
        type: 'error',
        title: 'oops...',
        text: "Favor informar o mês."
      });
      return;
    }
    else this.dataEspelho.mes = filtro.mes;

    if (filtro.ano == null || filtro.ano == "") {
      Swal.fire({
        type: 'error',
        title: 'oops...',
        text: "Favor informar o ano."
      });
      return;
    }
    else this.dataEspelho.ano = filtro.ano;

    this.loading = true;

    this.apiService.Get(`EspelhoPontos?ano=${filtro.ano}&mes=${filtro.mes}`).then(
      result => {
        this.listaEspelhos = result;
        this.loading = false;
      },
      err => {
        this.loading = false;
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });    
      }
    );
  }
  
  printFuncionario(espelho) {
    console.log(this.dataEspelho);
    this.loading = true;
    this.apiService.Get(`EspelhoPontos/Espelho?grupo_escala_uuid=${espelho.grupo_escala_uuid}&imprimir=true&mes=${this.dataEspelho.mes}&ano=${this.dataEspelho.ano}`).then(result => {
    },
      err => {
        if (err.status == 200) {
          let dataAtual = new Date()
          let mesAtual = dataAtual.getMonth()
          let anoAtual = dataAtual.getFullYear()
          var result = saveAs(err['error']['text'], `espelho-de-ponto-${mesAtual}/${anoAtual}.pdf`);
          this.loading = false;
          return
        }
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
        console.log(err)
      }
    )
    
  }
  
}



// WEBPACK FOOTER //
// ./src/app/pages/espelho-ponto/espelho-ponto.component.ts